import React, { lazy } from 'react';
import { dashboardPagesMenu, demoPagesMenu, pageLayoutTypesPagesMenu, companyPageMenues, financeReportPageMenues, customerPageMenues, programMenues, saloonPageMenues, calendarPageMenues, marketingPageMenues, organizationsAndLessonsPageMenues } from '../menu';
import Login from '../pages/presentation/auth/Login';
import Profile from '../pages/User/User';

const LANDING = {
	DASHBOARD: lazy(() => import('../pages/presentation/dashboard/DashboardPage')),
};

const COMPANY = {
	DETAILS: lazy(() => import("../pages/company/Details")),
	USERS: lazy(() => import('../pages/company/Users')),
	USER: lazy(() => import('../pages/company/User')),
	COMPANY: lazy(() => import('../pages/company/Company')),
	GALLERY: lazy(() => import('../pages/company/Gallery')),
	CERTIFICATES: lazy(() => import('../pages/company/Cartificates')),
	GATE: lazy(() => import('../pages/company/Gate')),
	FIELDS: lazy(() => import('../pages/company/Fields')),
	SALES: lazy(() => import('../pages/company/Sales')),
	PRODUCTS: lazy(() => import('../pages/company/Products')),
	LOADS: lazy(() => import('../pages/company/Loads')),
	POINTS: lazy(() => import('../pages/company/Points')),
	BANNERS: lazy(() => import('../pages/company/Banners')),
	AGGREEMENT: lazy(() => import('../pages/company/Aggreement')),
	PAYMENTS: lazy(() => import('../pages/company/Payments')),
};

const FINANCE = {
	ACCOUNTS: lazy(() => import("../pages/finance/Accounts")),
	TRANSACTIONS: lazy(() => import("../pages/finance/Transactions")),
	GENERAL: lazy(() => import("../pages/finance/GeneralReport")),
	INCOME: lazy(() => import("../pages/finance/Income")),
	OUTCOME: lazy(() => import("../pages/finance/Outcome")),
	STAFFPORTIONS: lazy(() => import("../pages/finance/StaffPortions")),
	DAILY_REPORT: lazy(() => import("../pages/finance/DailyReport"))
}

const PROGRAM = {
	FOODS: lazy(() => import("../pages/nutrition/Foods")),
	RECIPES: lazy(() => import("../pages/nutrition/Recipes")),
	SETS: lazy(() => import("../pages/nutrition/Sets")),
	PROGRAMS: lazy(() => import("../pages/nutrition/Programs")),
	MOVEMENTS: lazy(() => import("../pages/workouts/Movements")),
	WORKOUTS: lazy(() => import("../pages/workouts/Workouts")),

}

const CUSTOMER = {
	ACTIVE: lazy(() => import("../pages/customers/ActiveCustomers")),
	SUBSCRIPTIONS: lazy(() => import("../pages/customers/Subscriptions")),
	NUTRITIONS: lazy(() => import("../pages/customers/Nutritions")),
	WORKOUTS: lazy(() => import("../pages/customers/Workouts")),
	MESSAGES: lazy(() => import("../pages/customers/Messages")),
	NOTIFICATIONS: lazy(() => import("../pages/customers/CustomerNotifications")),
	EVENTS: lazy(() => import("../pages/customers/CustomerEvents")),
	ACTIVE_REPORT: lazy(() => import("../pages/customers/ActiveReport")),
}

const CALENDAR = {
	SETTINGS: lazy(() => import('../pages/calendar/Settings')),
	RESERVATION: lazy(() => import('../pages/calendar/Reservation')),
	EVENTS: lazy(() => import('../pages/calendar/Events')),
	PERIODIC_EVENTS: lazy(() => import('../pages/calendar/PeriodicEvents')),
}

const MARKETING = {
	FORMS: lazy(() => import('../pages/marketing/Forms')),
	SALES: lazy(() => import('../pages/marketing/Sales')),
	STATS: lazy(() => import('../pages/marketing/Stats')),
	CALL_LISTS: lazy(() => import('../pages/marketing/CallLists')),
	CONTACT_REPORTS: lazy(() => import('../pages/marketing/ContactReports')),
}

const CAMP_AND_LESSONS = {
	ORGANIZATIONS: lazy(() => import('../pages/camp-and-lessons/Organizations')),
	LESSONS: lazy(() => import('../pages/camp-and-lessons/Lessons')),
	TOPICS: lazy(() => import('../pages/camp-and-lessons/Topics')),
	LESSON_RECORDS: lazy(() => import('../pages/camp-and-lessons/LessonRecords')),
}

const COMPONENT = {
	CATEGORIES: lazy(() => import('../pages/components/Categories')),
}

const MAIN_PAGES = {
	MANAGER: lazy(() => import('../pages/presentation/mainpages/Manager')),
}

const AUTH = {
	PAGE_404: lazy(() => import('../pages/presentation/auth/Page404')),
};
const PAGE_LAYOUTS = {
	HEADER_SUBHEADER: lazy(() => import('../pages/presentation/page-layouts/HeaderAndSubheader')),
	HEADER: lazy(() => import('../pages/presentation/page-layouts/OnlyHeader')),
	SUBHEADER: lazy(() => import('../pages/presentation/page-layouts/OnlySubheader')),
	CONTENT: lazy(() => import('../pages/presentation/page-layouts/OnlyContent')),
	BLANK: lazy(() => import('../pages/presentation/page-layouts/Blank')),
	ASIDE: lazy(() => import('../pages/presentation/aside-types/DefaultAsidePage')),
	MINIMIZE_ASIDE: lazy(() => import('../pages/presentation/aside-types/MinimizeAsidePage')),
};

const presentation = [
	/**
	 * Landing
	 */
	{
		path: dashboardPagesMenu.dashboard.path,
		element: <LANDING.DASHBOARD />,
	},
	{
		path: demoPagesMenu.page404.path,
		element: <AUTH.PAGE_404 />,
	},
	{
		path: demoPagesMenu.login.path,
		element: <Login />,
	},
	{
		path: demoPagesMenu.signUp.path,
		element: <Login isSignUp />,
	},
	{
		path: "/profil",
		element: <Profile />,
	},
	/** ************************************************** */

	/**
			* Company
	  */
	{
		path: companyPageMenues.users.path,
		element: <COMPANY.USERS />,
	},
	{
		path: `${companyPageMenues.users.path}/user-detail`,
		element: <COMPANY.USER />,
	},
	{
		path: `${companyPageMenues.company.path}`,
		element: <COMPANY.DETAILS />,
	},
	{
		path: `${saloonPageMenues.saloonDetail.subMenu.saloonGeneralInfo.path}`,
		element: <COMPANY.COMPANY />,
	},
	{
		path: `${saloonPageMenues.saloonDetail.subMenu.saloonGallery.path}`,
		element: <COMPANY.GALLERY />,
	},
	{
		path: `${saloonPageMenues.saloonDetail.subMenu.saloonCertificates.path}`,
		element: <COMPANY.CERTIFICATES />,
	},
	{
		path: `${saloonPageMenues.gates.path}`,
		element: <COMPANY.GATE />,
	},
	{
		path: `${saloonPageMenues.places.path}`,
		element: <COMPANY.FIELDS />,
	},
	{
		path: `${saloonPageMenues.saloonBar.subMenu.barSales.path}`,
		element: <COMPANY.SALES />,
	},
	{
		path: `${saloonPageMenues.saloonBar.subMenu.barProducts.path}`,
		element: <COMPANY.PRODUCTS />,
	},
	{
		path: `${saloonPageMenues.saloonBar.subMenu.barLoads.path}`,
		element: <COMPANY.LOADS />,
	},
	{
		path: `${saloonPageMenues.saloonBar.subMenu.barBalance.path}`,
		element: <COMPANY.POINTS />,
	},
	{
		path: `${saloonPageMenues.aggreements.path}`,
		element: <COMPANY.AGGREEMENT />,
	},
	{
		path: `${saloonPageMenues.banners.path}`,
		element: <COMPANY.BANNERS />,
	},
	{
		path: companyPageMenues.payments.path,
		element: <COMPANY.PAYMENTS />,
	},
	/** ************************************************** */

	/**
		* Programs
  */
	{
		path: programMenues.foods.subMenu.foods.path,
		element: <PROGRAM.FOODS />,
	},
	{
		path: programMenues.foods.subMenu.recipes.path,
		element: <PROGRAM.RECIPES />,
	},
	{
		path: programMenues.nutrition.subMenu.sets.path,
		element: <PROGRAM.SETS />,
	},
	{
		path: programMenues.nutrition.subMenu.nutritionPrograms.path,
		element: <PROGRAM.PROGRAMS />,
	},

	{
		path: programMenues.workout.subMenu.movements.path,
		element: <PROGRAM.MOVEMENTS />,
	},

	{
		path: programMenues.workout.subMenu.workouts.path,
		element: <PROGRAM.WORKOUTS />,
	},
	/** ************************************************** */

	/**
			* Finance
	  */
	{
		path: `${financeReportPageMenues.monthlyBalance.subMenu.general.path}`,
		element: <FINANCE.GENERAL />,
	},
	{
		path: `${financeReportPageMenues.monthlyBalance.subMenu.income.path}`,
		element: <FINANCE.INCOME />,
	},
	{
		path: `${financeReportPageMenues.monthlyBalance.subMenu.outcome.path}`,
		element: <FINANCE.OUTCOME />,
	},
	{
		path: `${financeReportPageMenues.accounts.subMenu.accounts.path}`,
		element: <FINANCE.ACCOUNTS />,
	},
	{
		path: `${financeReportPageMenues.accounts.subMenu.transactions.path}`,
		element: <FINANCE.TRANSACTIONS />,
	},
	{
		path: `${financeReportPageMenues.specialReports.subMenu.staffPortions.path}`,
		element: <FINANCE.STAFFPORTIONS />,
	},
	{
		path: `${financeReportPageMenues.specialReports.subMenu.dailyreport.path}`,
		element: <FINANCE.DAILY_REPORT />,
	},
	/** ************************************************** */

	/**
		* Customer
		*/

	{
		path: `${customerPageMenues.customers.path}`,
		element: <CUSTOMER.ACTIVE />,
	},
	{
		path: `${customerPageMenues.activeReport.path}`,
		element: <CUSTOMER.ACTIVE_REPORT />,
	},
	{
		path: `${customerPageMenues.subscriptions.path}`,
		element: <CUSTOMER.SUBSCRIPTIONS />,
	},
	{
		path: `${customerPageMenues.customerPrograms.subMenu.customerNutritions.path}`,
		element: <CUSTOMER.NUTRITIONS />,
	},
	{
		path: `${customerPageMenues.customerPrograms.subMenu.customerWorkouts.path}`,
		element: <CUSTOMER.WORKOUTS />,
	},
	{
		path: `${customerPageMenues.customerPrograms.subMenu.customerEvents.path}`,
		element: <CUSTOMER.EVENTS />,
	},
	{
		path: `${customerPageMenues.messages.path}`,
		element: <CUSTOMER.MESSAGES />,
	},

	{
		path: `${customerPageMenues.customerNotifications.path}`,
		element: <CUSTOMER.NOTIFICATIONS />,
	},

	/** ************************************************** */

	/**
		* Calendar
		*/
	{
		path: `${calendarPageMenues.calendarSettings.path}`,
		element: <CALENDAR.SETTINGS />,
	},
	{
		path: `${calendarPageMenues.calendarList.path}`,
		element: <CALENDAR.RESERVATION />,
	},
	{
		path: `${calendarPageMenues.allEvents.path}`,
		element: <CALENDAR.EVENTS />,
	},
	{
		path: `${calendarPageMenues.myEvents.path}`,
		element: <CALENDAR.EVENTS />,
	},
	{
		path: `${calendarPageMenues.periodicEvents.path}`,
		element: <CALENDAR.PERIODIC_EVENTS />,
	},

	/** ************************************************** */

	/**
		* Marketing
		*/
	{
		path: `${marketingPageMenues.forms.path}`,
		element: <MARKETING.FORMS />,
	},
	{
		path: `${marketingPageMenues.allForms.path}`,
		element: <MARKETING.FORMS />,
	},
	{
		path: `${marketingPageMenues.marketingSales.subMenu.contactBase.path}`,
		element: <MARKETING.SALES />,
	},
	{
		path: `${marketingPageMenues.marketingSales.subMenu.staffBase.path}`,
		element: <MARKETING.SALES />,
	},
	{
		path: `${marketingPageMenues.marketingStats.subMenu.contactBaseStats.path}`,
		element: <MARKETING.STATS />,
	},
	{
		path: `${marketingPageMenues.marketingStats.subMenu.staffBaseStats.path}`,
		element: <MARKETING.STATS />,
	},
	{
		path: `${marketingPageMenues.callLists.path}`,
		element: <MARKETING.CALL_LISTS />,
	},
	{
		path: `${marketingPageMenues.contactReports.path}`,
		element: <MARKETING.CONTACT_REPORTS />,
	},
	/** ************************************************** */

	/**
		* Organizations and Lessons
		*/
	{
		path: organizationsAndLessonsPageMenues.organizations.path,
		element: <CAMP_AND_LESSONS.ORGANIZATIONS />,
	},
	{
		path: organizationsAndLessonsPageMenues.lessons.subMenu.lessonsList.path,
		element: <CAMP_AND_LESSONS.LESSONS />,
	},
	{
		path: organizationsAndLessonsPageMenues.lessons.subMenu.topics.path,
		element: <CAMP_AND_LESSONS.TOPICS />,
	},
	{
		path: organizationsAndLessonsPageMenues.records.path,
		element: <CAMP_AND_LESSONS.LESSON_RECORDS />,
	},

	/** ************************************************** */

	{
		path: "/definitions/categories",
		element: <COMPONENT.CATEGORIES />,
	},

	/**
			* Main Pages
	  */

	{
		path: "/dashboard/management-detail",
		element: <MAIN_PAGES.MANAGER />,
	},

	/** ************************************************** */
	/**
	 * Page Layout Types
	 */
	{
		path: pageLayoutTypesPagesMenu.blank.path,
		element: <PAGE_LAYOUTS.BLANK />,
	},
	{
		path: pageLayoutTypesPagesMenu.pageLayout.subMenu.headerAndSubheader.path,
		element: <PAGE_LAYOUTS.HEADER_SUBHEADER />,
	},
	{
		path: pageLayoutTypesPagesMenu.pageLayout.subMenu.onlyHeader.path,
		element: <PAGE_LAYOUTS.HEADER />,
	},
	{
		path: pageLayoutTypesPagesMenu.pageLayout.subMenu.onlySubheader.path,
		element: <PAGE_LAYOUTS.SUBHEADER />,
	},
	{
		path: pageLayoutTypesPagesMenu.pageLayout.subMenu.onlyContent.path,
		element: <PAGE_LAYOUTS.CONTENT />,
	},
	{
		path: pageLayoutTypesPagesMenu.asideTypes.subMenu.defaultAside.path,
		element: <PAGE_LAYOUTS.ASIDE />,
	},
	{
		path: pageLayoutTypesPagesMenu.asideTypes.subMenu.minimizeAside.path,
		element: <PAGE_LAYOUTS.MINIMIZE_ASIDE />,
	},
];
const contents = [...presentation];

export default contents;
